import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-auto-flow: row;
  justify-items: center;
  padding: 24px 16px;
  max-width: 312px;
  & > button {
    max-width: 180px;
    max-height: 44px;
    margin-bottom: 16px;
  }
  & > button.MuiLink-button {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  & > svg {
    margin-bottom: 16px;
  }
`;

const PanelTitle = styled.h3`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: #494c66;
  margin-bottom: 8px;
`;

const ChildrenContainer = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #494c66;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 24px;
`;

export { Container, PanelTitle, ChildrenContainer };
